import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";

// Helper
import yup from "../../../helpers/Validation";
import Helper from "../../../helpers/Helper";
import Regex from "../../../helpers/Regex";
import { country_code } from "../../../helpers/Constant";

class Step1 extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _onSubmit = (data) => {
    this.props.onSubmit(data, "2");
  };

  _validationSchema = () => {
    const form = this.form;
    const formValues = form.state.values;
    return yup.object({
      country_code: yup.string().required("Please select country code."),
      phone_no: yup
        .string()
        .required("Please enter phone no.")
        .test("digits", "Please enter only digits.", (value) => {
          let valid = true;
          if (value) {
            const regex = Regex.digits;
            valid = regex.test(value);
          }

          return valid;
        })
        .min(Helper.getPhoneNoMinLength(formValues.country_code))
        .max(Helper.getPhoneNoMaxLength(formValues.country_code))
        .test("phone", "Please enter valid phone no", (value) => {
          let valid = true;

          if (value) {
            if (value.charAt(0) === "0") {
              value = value.substring(1);
            }
            const form = this.form;
            const values = form.state.values;

            valid = Helper.validatePhoneWithCountryCode(
              value,
              values.country_code
            );
          }

          return valid;
        }),
    });
  };

  _handleSubmit = () => {
    const form = this.form;
    const { errors } = form.state;

    let valid = JSON.stringify(errors) === JSON.stringify({});
    if (!valid) {
      // Scroll to first invalid element
      let firstError = Object.keys(errors)[0];
      let refName = "fm_" + firstError;

      if (this[refName]) {
        // window.scrollTo(0, this[refName].offsetTop + 110);
      } else {
        // console.log("Error: Field not found. " + refName);
      }
    }
  };

  render() {
    const { data } = this.props;
    return (
      <Formik
        ref={(el) => (this.form = el)}
        validationSchema={this._validationSchema}
        onSubmit={this._onSubmit}
        initialValues={data}
        validateOnBlur={true}
      >
        {({
          validateForm,
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          isValid,
          isSubmitting,
          submitCount,
          touched,
          dirty,
          errors,
        }) => {
          return (
            <Form
              noValidate
              className="h-100 d-flex flex-column flex-grow-1 justify-content-between"
              onSubmit={handleSubmit}
            >
              <h3 className="step">Step 1</h3>
              <h5>
                Please enter your phone number to receive a verification code.
              </h5>
              <div className="flex-grow-1">
                <Form.Group>
                  <Form.Row>
                    <Col xs={5} md={4} controlid="validationCountryCode">
                      <Form.Label>Country Code</Form.Label>
                      <Form.Control
                        placeholder="Country Code"
                        as="select"
                        name="country_code"
                        value={values.country_code}
                        onChange={(e) => {
                          handleChange(e);
                          this.props.onChangePhoneNo();
                        }}
                        onBlur={handleBlur}
                        isInvalid={!!errors.country_code}
                        ref={(ref) => {
                          this.fm_country_code = ref;
                        }}
                      >
                        {country_code.map((data) => (
                          <option key={data.dial_code} value={data.dial_code}>
                            {data.dial_code}
                          </option>
                        ))}
                      </Form.Control>
                    </Col>
                    <Col xs={7} md={8} controlid="validationPhoneNo">
                      <Form.Label>Phone No.</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Phone No."
                        name="phone_no"
                        value={values.phone_no}
                        onChange={(e) => {
                          handleChange(e);
                          this.props.onChangePhoneNo();
                        }}
                        onBlur={handleBlur}
                        isInvalid={!!touched.phone_no && !!errors.phone_no}
                        maxLength={Helper.getPhoneNoMaxLength(
                          values.country_code
                        )}
                        ref={(ref) => {
                          this.fm_phone_no = ref;
                        }}
                      />
                      {!!touched.phone_no && !!errors.phone_no && (
                        <Form.Control.Feedback type="invalid">
                          {errors.phone_no}
                        </Form.Control.Feedback>
                      )}
                    </Col>
                  </Form.Row>
                </Form.Group>
              </div>
              <Row>
                <Col>
                  <Button
                    className="mt-4"
                    variant="light"
                    block
                    onClick={this.props.onBack}
                  >
                    Back
                  </Button>
                </Col>
                <Col>
                  <Button
                    type="submit"
                    variant="primary"
                    className="mt-4"
                    block
                    disabled={isSubmitting}
                    onClick={() => {
                      if (submitCount === 0) {
                        validateForm().then(() => {
                          this._handleSubmit();
                        });
                      } else {
                        this._handleSubmit();
                      }
                    }}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

Step1.propTypes = {
  data: PropTypes.object.isRequired,
  // Function
  onChangePhoneNo: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Step1;
